var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"honor-container"},[_c('div',{staticClass:"honor-head"},[_c('p',[_vm._v(_vm._s(_vm.title))])]),_c('div',{staticClass:"honor-content"},[_c('img',{attrs:{"src":_vm.bgimg2,"alt":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }